import { Component, h, options, createRef } from 'preact';

class TcrTextInput extends Component
{
    inputRef = createRef();
    suggestionsRef = createRef();

    constructor(props)
    {
        super(props);

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onOptionClicked = this.onOptionClicked.bind(this);
    }

    onFocus(e)
    {
        this.setState({ focus: true });
    }

    onBlur(e)
    {
        // only set focus to false if
        // - both refs are set, otherwise null coalescing operator '?.' will return undefined wich is !== false
        // - the related target (the element that is getting focus) is not part of the suggestions list
        // - the related target is not the input itself (happens when clicking on the input again)
        if (
            this.suggestionsRef.current?.contains(e.relatedTarget) === false &&
            this.inputRef.current?.contains(e.relatedTarget) === false
        ) {
            this.setState({ focus: false });
        }
    }

    onOptionClicked(value)
    {
        //console.log('clicked', value, typeof value);
        this.props.onInput({ target: { value: value }});
    }

    render()
    {
        let value = this.props.value || '';
        let beginSuggestions = Number.isInteger(this.props.beginSuggestions) && this.props.beginSuggestions >= 0 ? this.props.beginSuggestions : 1
        let suggestions = (this.props.suggestions || [])
        .filter(s =>
        {
            // Not enough characters yet
            if (value.length < beginSuggestions) return false;
            
            // identical to input, no suggestion
            if (s == value) return false;

            // must start with input
            return s.toLowerCase().startsWith(value.toLowerCase());
        })
        .map(s =>
        {
            return (
                <div class="option" data-value={s} onClick={() => this.onOptionClicked(s)}>{s}</div>
            );
        });

        return [
            <input ref={this.inputRef} type="text" value={value} placeholder={this.props.placeholder} data-field={this.props.field} maxlength={this.props.maxlength} onInput={this.props.onInput} onFocus={this.onFocus} onBlur={this.onBlur} />,
            <div class="tcr-suggestions" ref={this.suggestionsRef} tabindex="-1" onFocus={this.onFocus} onBlur={this.onBlur} data-hide={!this.state.focus || suggestions.length === 0}>
                {suggestions}
            </div>
        ];
    }
}

export { TcrTextInput };
